import { useEffect, useState } from 'react'; // Import necessary hooks 
import ReactMarkdown from 'react-markdown'; 
import { useParams } from 'react-router-dom'; 
import NavBar from './NavBar';
import '../styles/Markdownpage.css';
import Footer from './Footer';

const MarkdownPage = () => {
  const { projectcategory, name } = useParams(); // Get both projectcategory and name
  const [markdownContent, setMarkdownContent] = useState(''); // Initialize state

  useEffect(() => {
    // Fetching the Markdown file with project category and project name
    fetch(`/projects/${projectcategory}/${name}.md`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text(); 
      })
      .then((text) => setMarkdownContent(text)) 
      .catch((error) => console.error('Error fetching Markdown:', error)); 
  }, [projectcategory, name]); // Update dependencies to reflect the new parameters

  return (
    <div className="MarkDownPage">
      <NavBar />
      <div className='MarkDownindex'>Hi This is a project under {projectcategory} category</div>
      <div className='MarkDownContent'>
        <ReactMarkdown
                    components={{
                      img: ({ node, ...props }) => {
                        return (
                          <div className="image">
                            <img
                              src={`/Images/${props.src}`} // Use props.src to get the image source
                              alt={props.alt} // Use props.alt for the alt text
                              style={{ maxWidth: '80%', height: 'auto' }} // Responsive styling
                            />
                          </div>
                        );
                      },
                      img: ({ node, ...props }) => {
                        // Check if the src contains video URL and render video if it does
                        const isVideo = props.src && props.src.includes('.mp4');
                        if (isVideo) {
                          return (
                            <div className="video">
                              <video
                                controls
                                src={props.src} // Use props.src to get the video source
                                style={{ maxWidth: '100%', height: 'auto' }} // Responsive styling
                              >
                                Your browser does not support the video tag.
                              </video>
                            </div>
                          );
                        }
                        return (
                          <div className="image">
                            <img
                              src={`/Images/${props.src}`} // Use props.src to get the image source
                              alt={props.alt} // Use props.alt for the alt text
                              style={{ maxWidth: '80%', height: 'auto' }} // Responsive styling
                            />
                          </div>
                        );
                      },
                    }}
                  >
                    {markdownContent}
        </ReactMarkdown>
      </div>
      <Footer />
    </div>
  );
};

export default MarkdownPage;